import axios from 'axios';
import md5 from 'js-md5';
import addinstance from './instance.js'

// const instance = axios.create({
//     baseURL: 'http://182.254.211.39/index.php',
//     headers:{
//         'Content-Type':'application/x-www-form-urlencoded'
//     },
//     transformRequest: [function (data) {  
//         data =qs.stringify(data);
//         return data;
//     }],
//      withCredentials:true,
//      crossDomain: true,  
//     });

function geturl(URL){
     let timestamp=new Date().getTime();
     let device='PC'
     return URL+'?device=PC&timestamp='+timestamp
}
const admin={
    
}
//登录
export const requestLogin = params => { 
    params.password=md5(params.password)
    return addinstance().post(geturl(`/index/login`),params);
 };
export const getUserList = params => { return axios.get(`${base}/user/list`, { params: getparam(params) }); };

export const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };

export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };

export const menulist= params=> {return addinstance().get(geturl(`/menu/list`),{params:params});}

export const privilegescheck= params=> {return addinstance().get(geturl(`/privileges/check`),{params:params});}
export const componentupload = params => { return addinstance().post(geturl(`/common/component/upload`),params);};









// WEBPACK FOOTER //
// ./src/api/api.js